<template>
  <div>
    <v-layout wrap>
      <v-flex 
      v-for="item in items"
      :key="item.id"
      xs6
      pa-2>
        <label-row
        :item="item">
        </label-row>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from 'axios'
import LabelRow from './label-row'

export default {
  props: ['id'],
  components: {
    LabelRow
  },
  data () {
    return {
      items: []
    }
  },
  methods: {
    reload () {
      return axios.all([
        this.$axios.get('/delivery-items/' + this.id)
        ])
        .then(axios.spread((items) => {
          this.items = items.data
        }))
        .catch(error => this.$root.$errorSnackbar(error))
        .then(() => this.snackbarLoading = false)
    }
  },
  created () {
    this.reload()
  }
}
</script>
